<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>

<div *ngIf="IsInDesignMode" class="grid-design-div">
    <div class="{{this.Mode =='design' ? 'design-mode-field-label' : 'field-label'}}"><mat-label *ngIf="this.ShowLabel">{{this.DisplayName}} <span *ngIf="this.FormField.required" style="color:red">*</span></mat-label></div>
    <app-grid-field-designer #gridFieldDesigner
                             [gridFormFieldComponent]="WrappedGridFormFieldComponent"
                             (initialized)="handleGridFieldFieldDesignerInit()"
                             (onEdit)="handleEditFieldProperty($event)">
    </app-grid-field-designer>
</div>

<div *ngIf="IsInPreviewOrInstanceMode" class="preview-and-instance-modes-div">

    <div class="field-label" *ngIf="this.DisplayName">{{this.DisplayName}}</div>

    <button [disabled]="FormField.readOnly" mat-stroked-button style="margin:10px;" (click)="openNewContactDialog()">New Contact</button>
    <button [disabled]="FormField.readOnly" mat-stroked-button style="margin:10px;" (click)="addMeButtonClicked()">Add Me</button>


    <!--[disabled]="this.EmailAllButtonDisabled"-->
    <button mat-stroked-button style="margin:10px;"
            title="{{this.EmailAllToolTip}}"
            matTooltip="{{this.EmailAllToolTip}}"
            [matTooltipPosition]="this.TooltipPosition"
            (click)="this.showEmailDialog()">
        Email All Contacts
    </button>

    <button mat-stroked-button style="margin:10px;"
            title="{{this.AutomatedNotificationToolTip}}"
            matTooltip="{{this.AutomatedNotificationToolTip}}"
            [matTooltipPosition]="this.TooltipPosition"
            (click)="this.automatedNotificationDialog()">
        Automated Notification
    </button>

    <app-grid-field-editor #gridFieldEditor
                           [flavor]="ContactsGridFlavor"
                           [formInstance]="FormInstance"
                           [gridFormFieldComponent]="WrappedGridFormFieldComponent"
                           [isFootnotesGrid]="false"
                           (editorGridValidation)="this.handleEditorGridValidation($event)"
                           (conditionalLogicColumnDefsFilter)="this.handleConditionalLogicColumnDefsFilter($event)"
                           (gridEvent)="this.handleGridEvent($event)">
    </app-grid-field-editor>
</div>
